import { render } from "./searchResultsMenu.vue?vue&type=template&id=4f3857c6&scoped=true"
import script from "./searchResultsMenu.vue?vue&type=script&lang=js"
export * from "./searchResultsMenu.vue?vue&type=script&lang=js"

import "./searchResultsMenu.vue?vue&type=style&index=0&id=4f3857c6&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3522\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3857c6"]])

export default __exports__